module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAASCAYAAABrXO8xAAABXUlEQVQ4T43TQYiNURjG8d8zYaKUtSxMaoqkbKwsNCmxslAWVmxEFpIshiWrWY2xk5JSFKUmCzsrxWqkGJKN2VopCnV0bt93O93pztx3c07ne//v8573PF80UUrZi8uYw378wQqWcT/Jzz49/aaUcg23sb0t1uzXcCbJ23o2AEsp87gzApzDexzHDezGbxxL8i6llENdwqjQX1SV57iLZziCr5it4BOcHdNef1yVT+IjduF0Bb9jzyZg/XwJ+3AdNyv4a4OBtPUe4xFeYb6C3zAzgeIPfKjD6RUf4MIEYJtyoirWvr9gakJ4Jcnh/h2vYGkCsLZ7NMlq65zzWMTOMQU+D54hWR06p7FdHfXCGPBAkk/rvNpZbwsuoq5trCWpDhrGsNUO3Na1u2Mk52WSpxuBW3EVdW3jTZLXY8FO9RQO4l+XOI0X7f3WDacDq2/vdT9zteND3ErSFxrU+w92VW4EBwiRfAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tip.png
// module id = 5exV
// module chunks = 2